import React from 'react';
import { Container } from 'react-bootstrap';
import { withAuthorization } from '../Session';
import Users from './Users';

class InstaUsers extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Container>
                <Users {...this.props}></Users>
               
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(InstaUsers);
